import { useState } from "react";
import styles from "./borrowingCapacity.module.css";
import BorrowingCapacityResult from "./borrowingCapacityResult";
import BorrowingCapacityApllicantInfo1 from "./borrowingCapacityApllicantInfo1";
import BorrowingCapacityApllicantInfo2 from "./borrowingCapacityApllicantInfo2";

const BorrowingCapacity = ({ crmData }) => {
  // ✅ prefill from CRM data
  const [numberOfApplicants, setNumberOfApplicants] = useState(
    Number(crmData?.applicants?.count || 1)
  );
  const [numberOfDependant, setNumberOfDependant] = useState(
    Number(crmData?.applicants?.dependants || 0)
  );
  const [annualIncome1, setAnnualIncome1] = useState(
    Number(crmData?.income?.primaryIncome || 0)
  );
  const [annualIncome2, setAnnualIncome2] = useState(
    Number(crmData?.income?.secondaryIncome || 0)
  );
  const [monthlyRentalIncome, setMonthlyRentalIncome] = useState(
    Number(crmData?.income?.rentalIncome || 0)
  );
  const [creditCardLimit, setCreditCardLimit] = useState(
    Number(crmData?.expenses?.creditCards || 0)
  );
  const [personalLoanRepay, setPersonalLoanRepay] = useState(
    Number(crmData?.expenses?.personalLoan || 0)
  );
  const [homeLoanRepay, setHomeLoanRepay] = useState(
    Number(crmData?.expenses?.homeLoan || 0)
  );
  const [rate, setRate] = useState(4.79);
  const [year, setYear] = useState(30);
  const [serviceBuffer, setServiceBuffer] = useState(3);
  const [displayPart, setDisplayPart] = useState(1);

  return (
    <>
      <div className={`row g-6 ${styles.main_wrapper}`}>
        <div className={`row g-3 ${styles.data_wrapper}`}>
          {displayPart === 1 && (
            <BorrowingCapacityApllicantInfo1
              numberOfApplicants={numberOfApplicants}
              onNumberOfApplicantsChange={setNumberOfApplicants}
              numberOfDependant={numberOfDependant}
              dependants={Array.from({ length: 11 }, (_, i) => i)}
              onNumberOfDependantChange={setNumberOfDependant}
              rate={rate}
              onRateChange={setRate}
              year={year}
              years={Array.from({ length: 30 }, (_, i) => i + 1)}
              onYearsChange={setYear}
              annualIncome1={annualIncome1}
              annualIncome2={annualIncome2}
              onAnnualIncome1={setAnnualIncome1}
              onAnnualIncome2={setAnnualIncome2}
            />
          )}

          {displayPart === 2 && (
            <BorrowingCapacityApllicantInfo2
              creditCardLimit={creditCardLimit}
              onCreditCardChange={setCreditCardLimit}
              homeLoanRepay={homeLoanRepay}
              onHomeLoanRepayChange={setHomeLoanRepay}
              monthlyRentalIncome={monthlyRentalIncome}
              onRentalIncomeChange={setMonthlyRentalIncome}
              personalLoanRepay={personalLoanRepay}
              onPersonalLoanChange={setPersonalLoanRepay}
            />
          )}

          <div className={`col-m-6 ${styles.btn_row_container}`}>
            {displayPart === 1 && (
              <button
                className={`btn btn-secondary ${styles.btn_next}`}
                onClick={() => setDisplayPart(2)}
                disabled={annualIncome1 <= 0}
              >
                Next →
              </button>
            )}
            {displayPart === 2 && (
              <div style={{ display: "flex", gap: "12px", width: "100%" }}>
                <button
                  className={`btn btn-secondary ${styles.btn_next}`}
                  onClick={() => setDisplayPart(1)}
                >
                  Back
                </button>
                <button
                  className={`btn btn-secondary ${styles.btn_next}`}
                  onClick={() => {
                    window.dispatchEvent(new CustomEvent("bc-show-result"));
                  }}
                >
                  Show Result
                </button>
              </div>
            )}
          </div>
        </div>

        <div className={`row g-3 ${styles.data_wrapper}`}>
          <BorrowingCapacityResult
            numberOfApplicantsIn={numberOfApplicants}
            numberOfDependantIn={numberOfDependant}
            annualIncome1In={annualIncome1}
            annualIncome2In={annualIncome2}
            monthlyRentalIncomeIn={monthlyRentalIncome}
            creditCardLimitIn={creditCardLimit}
            personalLoanRepayIn={personalLoanRepay}
            homeLoanRepayIn={homeLoanRepay}
            yearIn={year}
            rateIn={rate}
            serviceBufferIn={serviceBuffer}
          />
        </div>
      </div>
    </>
  );
};

export default BorrowingCapacity;
